import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { BaseOptionType } from 'antd/lib/cascader';
import { DefaultOptionType } from 'antd/lib/select';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import { useGetCompanyList } from '../../hooks/useGetCompanyList';
import { CustomFormItem, CustomSelect } from '../styles';
import { OptionType } from '../types';

const { useFormInstance, useWatch } = Form;

export function CompanyFormItem() {
	const form = useFormInstance();
	const breakpoints = useBreakpoint();
	const organizationIds = useWatch('organization_ids', form);

	const { isLoading, data: companies, isError } = useGetCompanyList({ organization_ids: organizationIds! });

	function handleFilterOption(option: OptionType | DefaultOptionType | BaseOptionType, input: string): boolean {
		return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase());
	}

	const handleSelectAll = (value: string[]) => {
		if (value?.includes('all') && companies) {
			if (value.length === companies.length + 1) {
				return [];
			}
			return companies.filter((company) => !company.id.includes('all')).map((company) => company.id);
		}
		return value;
	};

	function companyDisable() {
		const isOrganizationIds = organizationIds?.length === 0;
		return isLoading || isOrganizationIds;
	}

	return (
		<CustomFormItem
			name={['company_ids']}
			label={I18n.get('Industrial site')}
			getValueFromEvent={handleSelectAll}
			rules={[
				{
					required: true,
					message: I18n.get('Select the industrial site')
				}
			]}
			style={{ height: 'auto' }}
		>
			<CustomSelect
				allowClear
				mode="multiple"
				showArrow={true}
				showSearch={true}
				loading={isLoading}
				maxTagCount="responsive"
				placeholder={I18n.get('Please select one or more')}
				size={!breakpoints.xxl ? 'small' : 'large'}
				filterOption={(input, option) => handleFilterOption(option, input)}
				options={companies?.map(({ id, name }) => ({ label: name, value: id }))}
				disabled={companyDisable() || isError}
			/>
		</CustomFormItem>
	);
}
